module.exports = __webpack_public_path__ + "img/Fehlertyp4_Dok1.0c5ce433.jpg";